import { Component, Input, ContentChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface StepItem {
  label: string;
  icon?: string; // Optional: CSS-Klasse für Icons (z.B. FontAwesome oder Material Icons)
}



@Component({
  selector: 'stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper.html',
  styleUrls: ['./stepper.css']
})
export class StepperComponent {
  @Input({ required: true }) steps: StepItem[] = [];
  @Input() activeIndex: number = 0; // z.B. 1.5 für die Mitte zwischen Step 2 und 3

  // Ermöglicht die Übergabe eines benutzerdefinierten Templates von außen
  @ContentChild('stepTemplate') stepTemplate?: TemplateRef<any>;

  get stepsCount(): number {
    return this.steps.length;
  }

  // Berechnet die Linienbreite dynamisch basierend auf der Schrittanzahl
  get progressWidth(): string {
    if (this.stepsCount <= 1) return '0%';
    const maxIndex = this.stepsCount - 1;
    const clampedIndex = Math.min(Math.max(this.activeIndex, 0), maxIndex);
    const percentage = (clampedIndex / maxIndex) * 100;
    return `${percentage}%`;
  }
}
